const WC_BLITZ_HOSTS = new Set(['wcblitz.com', 'www.wcblitz.com']);

export const SAM_ARMY_SIGNUP_PATH =
  '/register?redirect=%2Fwc%2Fknockout&source=sams_army&campaign=sam_launch&medium=social&content=sam_share_link';

export const SAMS_ARMY_SIGNUP_PATH =
  '/register?redirect=%2Fwc%2Fknockout&source=sams_army&campaign=sam_launch&medium=social&content=sams_army_slug';

export const SAM_ARMY_LANDING_PATH =
  '/wc/sam?source=sams_army&campaign=sam_launch&medium=social&content=sam_share_link';

export const SAMS_ARMY_LANDING_PATH =
  '/wc/sam?source=sams_army&campaign=sam_launch&medium=social&content=sams_army_slug';

const WC_BLITZ_APP_PREFIXES = [
  '/wc',
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/privacy',
  '/terms',
  '/official-rules',
  '/privacy-choices',
  '/accessibility',
  '/help',
  '/contact',
];
const WC_BLITZ_STATIC_PREFIXES = ['/assets/', '/badges/', '/wc-icon', '/wc-manifest', '/mmer-', '/mockup-'];
const WC_BLITZ_STATIC_PATHS = new Set([
  '/favicon.ico',
  '/injuries.json',
  '/momentum.json',
  '/robots.txt',
  '/sitemap.xml',
  '/sw.js',
]);

const normalizePath = (pathname: string): string => {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return path.replace(/\/+$/, '') || '/';
};

const hasRoutePrefix = (path: string, prefix: string): boolean =>
  path === prefix || path.startsWith(`${prefix}/`);

const isStaticPath = (path: string): boolean =>
  WC_BLITZ_STATIC_PATHS.has(path) ||
  WC_BLITZ_STATIC_PREFIXES.some((prefix) => path.startsWith(prefix)) ||
  /\/[^/]+\.[a-z0-9]+$/i.test(path);

export const resolveWCBlitzRedirect = (
  hostname: string | undefined,
  pathname: string
): string | null => {
  const host = hostname?.toLowerCase();
  if (!host || !WC_BLITZ_HOSTS.has(host)) {
    return null;
  }

  const path = normalizePath(pathname);

  if (path === '/sam') {
    return SAM_ARMY_LANDING_PATH;
  }

  if (path === '/sams-army') {
    return SAMS_ARMY_LANDING_PATH;
  }

  if (path === '/') {
    return '/wc/';
  }

  if (path === '/knockout') {
    return '/wc/knockout';
  }

  if (WC_BLITZ_APP_PREFIXES.some((prefix) => hasRoutePrefix(path, prefix)) || isStaticPath(path)) {
    return null;
  }

  return '/wc/';
};
